export default __webpack_public_path__ + "static/media/ZZC_7828.d7c92155.jpg";